<template>
  <div class="start-your-selection no-step">
    <h4 class="guide-header">{{ wizardTitle }}</h4>
    <div class="guide-content">
      <div v-if="activeStep === 'Select family'">
        <div class="form-group">
          <label for="voltageType">High/Low voltage</label>
          <multiselect
            id="voltageType"
            v-model="voltageType"
            :options="voltageTypeOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select High/Low voltage"
            :disabled="voltageTypeOptions.length < 2"
            @input="updateFamilyValues"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="families">Module Width</label>
          <multiselect
            id="moduleWidth"
            v-model="moduleWidth"
            :options="moduleWidthOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select a module width"
            @input="updateFamilyValues"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="families">Module family</label>
          <multiselect
            id="families"
            v-model="family"
            :options="familyOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select a family"
            @input="updateFamilyValues"
          ></multiselect>
        </div>
        <a
          href="javascript:void(0)"
          style="float: right"
          @click="onClearSelection"
          >Clear selection</a
        >
      </div>
      <div v-if="activeStep === 'Select filter'">
        <div class="form-group">
          <label for="families">Module family</label>
          <multiselect
            id="families"
            v-model="family"
            :options="familyOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select a family"
            :disabled="true"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="cri">CRI</label>
          <multiselect
            id="cri"
            v-model="cri"
            :options="criOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select CRI"
            :disabled="criOptions.length < 2"
            @input="updateValues"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="cct">CCT</label>
          <multiselect
            id="cct"
            v-model="cct"
            :options="cctOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select CCT"
            :disabled="cctOptions.length < 2"
            @input="updateValues"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="spectrum">Spectrum</label>
          <multiselect
            id="spectrum"
            v-model="spectrum"
            :options="spectrumOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select Spectrum"
            :disabled="spectrumOptions.length < 2"
            @input="updateValues"
          ></multiselect>
        </div>
        <div class="form-group">
          <label for="connector">FC/BC</label>
          <multiselect
            id="connector"
            v-model="connector"
            :options="connectorOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select FC/BC"
            :disabled="connectorOptions.length < 2"
            @input="updateValues"
          ></multiselect>
        </div>
        <a
          href="javascript:void(0)"
          style="float: right"
          @click="onClearSelection"
          >Clear selection</a
        >
      </div>
      <div v-if="activeStep === 'Multi length result'">
        <div class="your-preference">
          <div class="your-preference-results row">
            <div class="col">
              <div v-if="family" class="pref-item">
                <div class="pref-title"><span>Family</span></div>
                <div class="pref-value">
                  <span>{{ family }}</span>
                </div>
              </div>
              <div v-if="cri" class="pref-item">
                <div class="pref-title"><span>CRI</span></div>
                <div class="pref-value">
                  <span>{{ cri }}</span>
                </div>
              </div>
              <div v-if="cct" class="pref-item">
                <div class="pref-title"><span>CCT</span></div>
                <div class="pref-value">
                  <span>{{ cct }}</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div v-if="voltageType" class="pref-item">
                <div class="pref-title"><span>High/Low voltage</span></div>
                <div class="pref-value">
                  <span>{{ voltageType }}</span>
                </div>
              </div>
              <div v-if="spectrum" class="pref-item">
                <div class="pref-title"><span>Spectrum</span></div>
                <div class="pref-value">
                  <span>{{ spectrum }}</span>
                </div>
              </div>
              <div v-if="connector" class="pref-item">
                <div class="pref-title"><span>FC/BC</span></div>
                <div class="pref-value">
                  <span>{{ connector }}</span>
                </div>
              </div>
            </div>
          </div>
          <a href="javascript:void(0)" @click="onClearSelection"
            >Clear selection</a
          >
        </div>
        <h4 class="guide-header">Specify total length and preferred modules</h4>
        <div class="total-length">
          <label>
            <span class="distance-unit-select-title">Total length</span>
            <input
              type="text"
              v-model="totalLengthInput"
              class="form-control"
              @input="distributeLength"
              :class="{ invalid: invalidDistributionLength }"
            />
          </label>
          <label>
            <multiselect
              class="distance-unit-select"
              id="distanceUnits"
              :value="distanceUnitMultiLength"
              :options="distanceUnits"
              :searchable="false"
              :close-on-select="true"
              :show-labels="false"
              @input="distanceUnitMultiLengthChange"
            ></multiselect>
          </label>
        </div>
        <div class="pref-modules">
          <div
            v-for="(candidate, index) in candidates"
            :key="index"
            class="pref-module"
          >
            <label>
              <input
                type="text"
                class="form-control"
                :value="candidate.amount"
                @input="updateLength($event.target.value, candidate)"
              />
              {{ candidate.module.name }}
              <span class="length-span"
                >({{ getDistance(candidate.module.housing.length)
                }}<span v-text="distanceUnitMultiLength"></span>)</span
              >
            </label>
          </div>
        </div>
        <div v-if="totalNumberOfModules" class="result-length">
          Total length of {{ totalNumberOfModules }} selected modules:
          <span class="length-span"
            >{{ totalLengthOutput
            }}<span v-text="distanceUnitMultiLength"></span
          ></span>
        </div>
      </div>
    </div>
    <div class="btns-container row">
      <div class="col">
        <div class="btn btn-outline-secondary" @click="prev">Previous</div>
      </div>
      <div class="col">
        <div
          v-if="!isResultPage"
          class="btn btn-secondary"
          :class="{ disabled: disableNext }"
          @click="next"
        >
          Next
        </div>
        <div
          :class="{ disabled: disableNext }"
          v-if="isResultPage"
          class="btn btn-secondary"
          @click="addToSolution"
        >
          Add to solution
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { http } from "@/services/http";
import { EventBus } from "@/eventbus.js";
import { mapState } from "vuex";
import { debounce } from "lodash";

const ANY_OPTION = "Any";

export default {
  name: "MultiLength",
  props: ["activeStep", "steps", "withModule"],
  data() {
    return {
      candidates: [],
      totalLengthInput: null,
      family: null,
      familyOptions: [],
      cri: null,
      criOptions: [],
      cct: null,
      cctOptions: [],
      voltageType: null,
      voltageTypeOptions: [],
      spectrum: null,
      spectrumOptions: [],
      connector: null,
      connectorOptions: [],
      invalidDistributionLength: false,
      moduleWidth: null,
      moduleWidthOptions: [],
      distanceUnits: ["mm", "cm", "inch", "ft"],
      prevDistanceUnit: this.distanceUnitMultiLength,
    };
  },
  computed: {
    ...mapState("brain", ["distanceUnitMultiLength", "region"]),
    ...mapState("brain/modules", {
      module: "module",
    }),

    wizardTitle() {
      return this.isResultPage
        ? "Your preference"
        : "Please select your preference";
    },
    isResultPage() {
      return this.activeStep === "Multi length result";
    },
    disableNext() {
      switch (this.activeStep) {
        case "Select family":
          return this.family === null || this.voltageType === null;
        case "Select filter":
          return (
            this.cri === null ||
            this.cct === null ||
            this.spectrum === null ||
            (this.connectorOptions.length > 1 && this.connector === null)
          );
        case "Multi length result":
          return this.totalNumberOfModules < 1;
        default:
          return true;
      }
    },
    totalLengthOutput() {
      let length = 0;
      this.candidates.map((candidate) => {
        length +=
          this.getDistance(candidate.module.housing.length) * candidate.amount;
      });
      return Math.round(length * 10) / 10;
    },
    totalNumberOfModules() {
      let amount = 0;
      this.candidates.map((candidate) => {
        amount += Number(candidate.amount);
      });
      return amount;
    },
  },
  mounted() {
    this.$store.dispatch("brain/solutions/removeProductHeaders");
    this.fillFirstOptions();

    if (this.withModule) {
      this.family = this.module.familyLevelFour;
      this.moduleWidth = this.module.housing.width;
      this.cri = this.module.criRef;
      this.cct = this.module.cctRef;
      this.spectrum = this.module.specialSpectrum;
      this.connector = this.module.connector;
      this.voltageType = this.module.voltageTypes[0].name;
      this.$emit("setActiveStep", "Multi length result");
      this.updateValues();
      this.getModuleResult(true);
    }
  },
  methods: {
    prefillValues() {
      if (this.criOptions.length === 1) {
        this.cri = this.criOptions[0];
      }
      if (this.cctOptions.length === 1) {
        this.cct = this.cctOptions[0];
      }
      if (this.spectrumOptions.length === 1) {
        this.spectrum = this.spectrumOptions[0];
      }
      if (this.voltageTypeOptions.length === 1) {
        this.voltageType = this.voltageTypeOptions[0];
      }
      if (this.connectorOptions.length === 1) {
        this.connector = this.connectorOptions[0];
      }
    },
    async fillFirstOptions() {
      let formData = new FormData();
      formData.append("tags.3_multi_length[]", "Multi Length");
      if (this.family) formData.append("productFamily4[]", this.family);
      if (this.moduleWidth)
        formData.append(
          "housingWidth[]",
          this.moduleWidth === ANY_OPTION ? "" : this.moduleWidth
        );
      if (this.voltageType)
        formData.append("moduleVoltageType[]", this.voltageType);

      await this.getModules(formData, true).then((res) => {
        this.familyOptions = res.filters
          .find((x) => x.name === "moduleFamilyFilter_4")
          .availableValues.filter((family) => family.count !== 0)
          .map((family) => family.value);

        this.moduleWidthOptions = res.filters
          .find((x) => x.name === "housingWidthValues")
          .availableValues.filter((family) => family.count !== 0)
          .map((family) => family.value);
        this.moduleWidthOptions.unshift(ANY_OPTION);

        this.voltageTypeOptions = res.filters
          .find((x) => x.name === "moduleVoltageType")
          .availableValues.filter((voltageType) => voltageType.count !== 0)
          .map((voltageType) => voltageType.value);

        if (this.voltageTypeOptions.length === 1) {
          this.voltageType = this.voltageTypeOptions[0];
        }
      });
    },
    onClearSelection() {
      const newIndex = this.steps.findIndex((item) => item === "Select family");
      this.$emit("setActiveStep", this.steps[newIndex]);

      this.voltageType = null;
      this.moduleWidth = null;
      this.family = null;

      this.cri = null;
      this.cct = null;

      this.fillFirstOptions();
    },
    prev() {
      if (this.activeStep === "Select family") {
        this.$emit("prev", "howCanIHelp");
      }
      const newIndex =
        this.steps.findIndex((item) => item === this.activeStep) - 1;
      this.$emit("setActiveStep", this.steps[newIndex]);
    },
    next() {
      if (this.disableNext) return;
      const newIndex =
        this.steps.findIndex((item) => item === this.activeStep) + 1;

      switch (this.steps[newIndex]) {
        case "Select family":
          break;
        case "Select filter":
          this.updateValues();
          break;
        case "Multi length result":
          this.getModuleResult(true);
          break;
      }

      this.$emit("setActiveStep", this.steps[newIndex]);
    },
    async addToSolution() {
      if (this.disableNext) return;
      const system = this.candidates
        .filter((candidate) => candidate.amount > 0)
        .map((candidate) => {
          return { uid: candidate.module.uid, amount: candidate.amount };
        });
      let virtualModule = null;
      await http({
        method: "POST",
        url: "/api/v2/modules/multi-length/",
        data: {
          system: system,
          // The chosen voltage type drives series (HV) vs parallel (LV) distribution and is
          // required for modules mapped to both voltage types (combined HV/LV modules).
          parameters: { voltageType: this.voltageType },
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          virtualModule = response.data.data.system;
        })
        .catch(() => {
          this.$snotify.error("Invalid length distribution.");
        });

      if (virtualModule !== null) {
        const multiLengthModules = this.candidates
          .filter((candidate) => candidate.amount > 0)
          .map((candidate) => {
            candidate.module.amount = candidate.amount;
            return candidate.module;
          });

        this.augmentMultiLengthModules(virtualModule, multiLengthModules);

        await this.$store.dispatch("brain/solutions/setMultiLengthModules", {
          virtualModule,
          multiLengthModules,
          voltageType: this.voltageType,
        });

        if (this.$router.currentRoute.name !== "advanced") {
          this.$router.push({ name: "advanced" });
        }
        EventBus.$emit("setMultiLength");
        this.$emit("close");
      }
    },

    augmentMultiLengthModules(virtualModule, multiLengthModules) {
      let flux = virtualModule.calculationResult.outputFluxOfArray;
      let totalLength = 0;
      multiLengthModules.forEach((value) => {
        totalLength += value.housing.length;
      });
      let fluxPerLength = flux / totalLength;
      multiLengthModules.forEach((value) => {
        let amount = value.amount;
        let length = value.housing.length;
        value.calculationResult.luminousEfficacyOfModule =
          amount * length * fluxPerLength;
      });
    },

    updateValues() {
      let formData = new FormData();
      formData.append("tags.3_multi_length[]", "Multi Length");
      formData.append("productFamily4[]", this.family);

      if (this.moduleWidth)
        formData.append(
          "housingWidth[]",
          this.moduleWidth === ANY_OPTION ? "" : this.moduleWidth
        );
      if (this.voltageType)
        formData.append("moduleVoltageType[]", this.voltageType);

      if (this.cri) formData.append("criRef[]", this.cri);
      if (this.cct) formData.append("cctRef[]", this.cct);
      if (this.spectrum) formData.append("specialSpectrum[]", this.spectrum);
      if (this.connector) formData.append("connector[]", this.connector);

      this.getModules(formData, true)
        .then((res) => {
          this.criOptions = res.filters
            .find((x) => x.name === "cri_ref")
            .availableValues.filter((cri) => cri.count !== 0)
            .map((cri) => cri.value);

          this.cctOptions = res.filters
            .find((x) => x.name === "cct_ref")
            .availableValues.filter((cct) => cct.count !== 0)
            .map((cct) => cct.value);

          this.spectrumOptions = res.filters
            .find((x) => x.name === "special_spectrum")
            .availableValues.filter((spectrum) => spectrum.count !== 0)
            .map((spectrum) => spectrum.value);

          this.connectorOptions = res.filters
            .find((x) => x.name === "connector")
            .availableValues.filter((connector) => connector.count !== 0)
            .map((connector) => connector.value);
        })
        .then(() => {
          this.prefillValues();
        });
    },
    getModuleResult(init) {
      http({
        method: "POST",
        url: "/api/v2/modules/multi-length/distribution",
        data: {
          desiredLength: this.getTotalLength(this.totalLengthInput),
          cri: this.cri,
          cct: this.cct,
          voltageType: this.voltageType,
          spectrum: this.spectrum,
          familyName: this.family,
          connector: this.connector,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.invalidDistributionLength = false;
          this.candidates = response.data.data.candidates;
          this.candidates.map((candidate) => {
            if (candidate.amount === 0) {
              candidate.amount = null;
            }
          });
          if (!init) {
            this.$snotify.success("Length has been distributed.");
          }
        })
        .catch((err) => {
          this.$snotify.error(err.response.data.message);
          this.invalidDistributionLength = true;
        });
    },
    getModules(formData, sizeZero) {
      let url =
        "/api/v2/modules/data?hasMatchingDriver=true&whitelistingEnabled=true&showArchive=false";
      if (sizeZero) url += "&size=0";
      return http({
        method: "POST",
        url: url,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        return response.data.data;
      });
    },
    updateLength(newAmount, candidate) {
      this.invalidDistributionLength = false;
      const candidateIndex = this.candidates.findIndex(
        (x) => x.module === candidate.module
      );
      this.candidates[candidateIndex].amount = Number(newAmount);
    },

    distributeLength: debounce(function () {
      if (this.totalLengthInput === "") return;
      this.getModuleResult(false);
    }, 1000),

    updateFamilyValues() {
      this.clearInputs();
      this.fillFirstOptions();
    },

    clearInputs() {
      this.cri = null;
      this.cct = null;
      this.spectrum = null;
      this.connector = null;
      this.totalLengthInput = null;
    },

    distanceUnitMultiLengthChange(e) {
      this.prevDistanceUnit = this.distanceUnitMultiLength;
      this.$store.commit("brain/setDistanceUnitMultiLength", e);
      this.totalLengthInput = this.getTotalLengthInput(this.totalLengthInput);
    },

    getTotalLengthInput(distance) {
      switch (this.prevDistanceUnit) {
        case "mm":
          // mm to new unit
          switch (this.distanceUnitMultiLength) {
            case "cm":
              return Math.round((distance / 10) * 10) / 10;
            case "inch":
              return Math.round((distance / 25.4) * 100) / 100;
            case "ft":
              return Math.round((distance / 305) * 100) / 100;
            default:
              return Math.round(distance * 10) / 10;
          }
        case "cm":
          // cm to new unit
          switch (this.distanceUnitMultiLength) {
            case "mm":
              return Math.round(distance * 10 * 10) / 10;
            case "inch":
              return Math.round((distance / 2.54) * 100) / 100;
            case "ft":
              return Math.round((distance / 30.48) * 100) / 100;
            default:
              return Math.round(distance * 10) / 10;
          }
        // cm to new unit
        case "inch":
          // inch to new unit
          switch (this.distanceUnitMultiLength) {
            case "mm":
              return Math.round(distance * 25.4 * 10) / 10;
            case "cm":
              return Math.round(distance * 2.54 * 10) / 10;
            case "ft":
              return Math.round((distance / 12) * 100) / 100;
            default:
              return Math.round(distance * 100) / 100;
          }
        case "ft":
          // ft to new unit
          switch (this.distanceUnitMultiLength) {
            case "mm":
              return Math.round(distance * 305 * 10) / 10;
            case "cm":
              return Math.round(distance * 30.48 * 10) / 10;
            case "inch":
              return Math.round(distance * 12 * 100) / 100;
            default:
              return Math.round(distance * 100) / 100;
          }
      }
    },

    getDistance(distance) {
      if (this.region === "na") {
        // Convert inch to following:
        switch (this.distanceUnitMultiLength) {
          case "mm":
            return Math.round(distance * 25.4 * 10) / 10;
          case "cm":
            return Math.round(distance * 2.54 * 10) / 10;
          case "ft":
            return Math.round((distance / 12) * 100) / 100;
          default:
            // default is inch
            return Math.round(distance * 100) / 100;
        }
      } else {
        // Convert mm to following:
        switch (this.distanceUnitMultiLength) {
          case "cm":
            return Math.round((distance / 10) * 10) / 10;
          case "inch":
            return Math.round((distance / 25.4) * 100) / 100;
          case "ft":
            return Math.round((distance / 305) * 100) / 100;
          default:
            // default is mm
            return Math.round(distance * 10) / 10;
        }
      }
    },

    getTotalLength(length) {
      let convertedLength = null;
      if (this.region === "na") {
        // Convert to inch
        switch (this.distanceUnitMultiLength) {
          case "mm":
            convertedLength = length / 25.4;
            break;
          case "cm":
            convertedLength = length / 2.54;
            break;
          case "ft":
            convertedLength = length * 12;
            break;
          default:
            // default is inch
            convertedLength = length;
        }
      } else {
        // Convert to mm
        switch (this.distanceUnitMultiLength) {
          case "cm":
            convertedLength = length * 10;
            break;
          case "inch":
            convertedLength = length * 25.4;
            break;
          case "ft":
            convertedLength = length * 305;
            break;
          default:
            // default is mm
            convertedLength = length;
        }
      }

      return convertedLength !== "0" && convertedLength !== 0
        ? convertedLength
        : null;
    },
  },
};
</script>
<style lang="scss" scoped>
.guide-content .custom-control {
  padding: 0.15rem 0 0.15rem 1.8rem !important;
}

label {
  font-family: $headings-font-family;
  margin-bottom: 16px;
}

input {
  width: 20%;
  font-family: $font-family-sans-serif;

  &.invalid {
    border-color: #ff9494;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(255, 20, 20, 0.25);
  }
}

.total-length {
  margin-bottom: 16px;
  label {
    display: inline;
    width: 100%;
    input {
      margin-top: 8px;
      display: inline-block;
    }
  }
}

.pref-modules {
  .pref-module {
    label {
      width: 100%;

      input {
        display: inline-block;
        margin-right: 24px;
      }
    }
  }
}

.result-length {
  margin-top: 20px;
}

.length-span {
  color: $blue-500;
  font-family: $headings-font-family;
}

.your-preference {
  margin-bottom: 30px;

  .your-preference-results {
    padding: 32px;
    border: 1px solid #efefef;
    border-radius: 2px;
    box-shadow: 0 2px 17px 0 rgba(0, 0, 0, 0.07);
    margin-bottom: 10px;

    .pref-item {
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }

      .pref-title {
        font-family: $headings-font-family;
      }
    }
  }
}

.distance-unit-select {
  width: 80px;
  display: inline-block;
  margin-left: 10px;
}

.distance-unit-select-title {
  display: block;
}
</style>
